"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndEvent = void 0;
const Constants_1 = require("../Constants");
const EventBase_1 = require("./EventBase");
/**
 * Describes a BPMN EndEvent.
 * These are used to finish a process.
 *
 * Depending on the type of EndEvent used, the process will either be finished
 * with a success message or an error.
 */
class EndEvent extends EventBase_1.Event {
    get bpmnType() {
        return Constants_1.BpmnType.endEvent;
    }
    get eventType() {
        const eventIsErrorEvent = this.errorEventDefinition !== undefined;
        if (eventIsErrorEvent) {
            return Constants_1.EventType.errorEvent;
        }
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        const eventIsTerminateEvent = this.terminateEventDefinition !== undefined;
        if (eventIsTerminateEvent) {
            return Constants_1.EventType.terminateEvent;
        }
        return undefined;
    }
}
exports.EndEvent = EndEvent;
//# sourceMappingURL=EndEvent.js.map